export default __webpack_public_path__ + "static/media/pinetree.b537c530.jpg";